import * as React from 'react';
import { prefix, TopModelNameTransformProvider } from '@goldwasserexchange/react-topmodel';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import {
  RadioListInputStructure,
  radioListInputPrefixer,
  DefaultContextProviderContextsTopModelsProvider,
  DefaultListInputTopModelsProvider,
  DefaultRadioListInputTopModelsProvider,
} from '../../../../OUI/Inputs';
import {
  DefaultRadioListInputDomTopModelsProvider,
} from './topmodels';
import {
  DefaultIconContentDomTopModelsProvider,
  DefaultFooterDomTopModelsProvider,
  DefaultListInputDomTopModelsProvider,
} from '../shared';
import { DefaultInputErrorMessageTopModelsProvider, UseGetFnProps } from '../../../../OUI/Inputs/components';
import { SearchKeysProps } from '../../../../OUI/Inputs/components/shared/components/list/context/searchKeys/context';

export function RadioListInput(
  props: React.PropsWithChildren<
  {
    fieldPath: string,
    elementLines?: ouiStyle.InStyle['lines'],
    dependenciesFieldPaths?: string[],
  } & Partial<SearchKeysProps> & Partial<UseGetFnProps> & ouiBase.List.ListProps & ouiBase.List.ListDataFilterAndSortProviderProps
  >,
) {
  const {
    fieldPath,
    dependenciesFieldPaths,
    list,
    length,
    elementLines,
    useFilterFn,
    useSortFn,
    useGetFn,
    searchKeys,
    children,
  } = props;
  return (
    <TopModelNameTransformProvider transformFn={radioListInputPrefixer}>
      <DefaultContextProviderContextsTopModelsProvider>
        <DefaultIconContentDomTopModelsProvider>
          <DefaultFooterDomTopModelsProvider>
            <ouiBase.List.DefaultListContextTopModelsProvider
              transformBeforeFn={prefix('InputList')}
            >
              <ouiBase.List.DefaultListMapperTopModelsProvider
                transformBeforeFn={prefix('InputList')}
              >
                <ouiBase.List.DefaultListElementBaseTopModelsProvider
                  transformBeforeFn={prefix('InputList')}
                >
                  <ouiBase.List.DefaultListElementSubContextsTopModelsProvider
                    transformBeforeFn={prefix('InputList')}
                  >
                    <DefaultListInputTopModelsProvider>
                      <DefaultInputErrorMessageTopModelsProvider>
                        <DefaultListInputDomTopModelsProvider>
                          <DefaultRadioListInputTopModelsProvider>
                            <DefaultRadioListInputDomTopModelsProvider>
                              <RadioListInputStructure
                                fieldPath={fieldPath}
                                dependenciesFieldPaths={dependenciesFieldPaths}
                                list={list}
                                length={length}
                                elementLines={elementLines}
                                useFilterFn={useFilterFn}
                                useSortFn={useSortFn}
                                useGetFn={useGetFn}
                                searchKeys={searchKeys}
                              >
                                {children}
                              </RadioListInputStructure>
                            </DefaultRadioListInputDomTopModelsProvider>
                          </DefaultRadioListInputTopModelsProvider>
                        </DefaultListInputDomTopModelsProvider>
                      </DefaultInputErrorMessageTopModelsProvider>
                    </DefaultListInputTopModelsProvider>
                  </ouiBase.List.DefaultListElementSubContextsTopModelsProvider>
                </ouiBase.List.DefaultListElementBaseTopModelsProvider>
              </ouiBase.List.DefaultListMapperTopModelsProvider>
            </ouiBase.List.DefaultListContextTopModelsProvider>
          </DefaultFooterDomTopModelsProvider>
        </DefaultIconContentDomTopModelsProvider>
      </DefaultContextProviderContextsTopModelsProvider>
    </TopModelNameTransformProvider>
  );
}
